module.exports = __webpack_public_path__ + "img/summary1.2f1110ec.png";